import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

interface PdpLayoutState {
  [key: string]: any;
  updatedTime?: string;
}

const initialState: PdpLayoutState = {};

const pdpLayoutSlice = createSlice({
  name: "pdpLayout",
  initialState,
  reducers: {
    setPdpLayout: (state, action) => {
      return {
        ...state,
        ...action.payload,
        updatedTime: new Date().toISOString(),
      };
    },
    clearPdpData: (state) => {
      state.pdpLayout = initialState;
    },
  },
});

export const { setPdpLayout } = pdpLayoutSlice.actions;

export const { clearPdpData } = pdpLayoutSlice.actions;

export default pdpLayoutSlice.reducer;

export const getPdpLayout = (state) => state.pdpLayout;

export const usePdpLayout = () => {
  return useSelector(getPdpLayout);
};

export const usePDPSlice = () => {
  const pdpData = useSelector((state: any) => state.navigationMenu);

  return {
    pdpData,
  };
};
